// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import {
    loadShopByIndustryApiParameter,
    ShopByIndustryApiParameter,
    ShopByIndustryModal,
} from "@keller/App/Services/ShopByIndustryService";

type HandlerType = ApiHandler<ShopByIndustryApiParameter & HasOnSuccess & HasOnError<string>, ShopByIndustryModal>;

export const DispatchBeginLoadShopByIndustry: HandlerType = props => {
    props.dispatch({
        type: "xShopByIndustry/BeginLoadShopByIndustry" as any,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await loadShopByIndustryApiParameter(props.apiParameter);
    } catch (error) {
        const failedMessage =
            error.errorMessage || "Please try again and contact support if you continue to have issues.";
        props.parameter.onError?.(failedMessage);
        props.dispatch({ type: "xShopByIndustry/FailedToLoadShopByIndustry", failedMessage } as any);
        return false;
    }
};

export const DispatchCompleteLoadShopByIndustry: HandlerType = props => {
    props.dispatch({
        type: "xShopByIndustry/CompleteLoadShopByIndustry",
        data: props.apiResult,
    } as any);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [
    DispatchBeginLoadShopByIndustry,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadShopByIndustry,
    ExecuteOnSuccessCallback,
];

const loadShopByIndustry = createHandlerChainRunner(chain, "LoadShopByIndustry");
export default loadShopByIndustry;
